import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'hbo-regular-progress-modal',
  templateUrl: './regular-progress-modal.component.html',
  styleUrls: ['./regular-progress-modal.component.scss']
})
export class RegularProgressModalComponent implements OnChanges {

  @Input() id?: string | number;
  @Output() confirm = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;
  @Input() extendedMessage?: string;
  @Input() cancelText?: string;

  @Input() footer?:boolean;

  @Input() total?: number;
  @Input() phasesCompleted?: number;
  @Input() error?: boolean;
  @Input() innerHTMLStyle?: string;

  @Output() initialized = new EventEmitter<void>();

  constructor(
    public router: Router
  ) { }

  ngOnInit(){
    
  }
  ngAfterViewInit(){
    this.initialized.emit(); // notify parent it's rendered
  }

  ngOnChanges(changes: SimpleChanges) {
    this.error ? (
      this.extendedMessage = 'LICENSE.ERRORCREATINGPACKAGE',
      this.innerHTMLStyle = 'errorMessage text-danger'
    )
    :null;
  }

  goList = () => {
  }


}
